<div
  class="item"
  [class.pointer-events-none]="isDisabled()"
  (click)="toggleItem.emit()"
>
  <span class="pl-[7px]" [class.disabled]="isDisabled()">
    <input class="checkbox" type="checkbox" [checked]="item().isSelected" />
  </span>

  <shared-ui-node-icon
    class="pl-[14px]"
    [class.disabled]="isDisabled()"
    [color]="'gray'"
    [iconPath]="itemIconPath()"
  ></shared-ui-node-icon>

  <div class="item__text t:flex w-full pl-[14px] leading-[28px]">
    <span
      class="text-base-100 pr-[14px] !text-[17px] font-medium"
      [class.disabled]="isDisabled()"
    >
      {{ item().entity.serviceTag | mask: '###-###-###-###-###' }}
    </span>

    <span class="pr-[7px]" [class.disabled]="isDisabled()">
      {{ item().entity.modelName }}
    </span>

    @if (item().entity.addedInCurrentAccount) {
      <span
        class="ml-auto text-green-500"
        i18n="@@importRoutersModalAlreadyAdded"
        >Already imported</span
      >
    } @else if (item().entity.addedInAnotherAccount) {
      <span
        class="ml-auto text-yellow-500"
        i18n="@@importRoutersModalAlreadyAddedToAnother"
        >Added to another account</span
      >
    }
  </div>
</div>
